import store from '../store.js'
import {addNotificationMessage,setGlobalKey,addUsers,addScript} from '../actions/General.js';
import axios from 'axios';
import Auth from '../modules/Auth.js';
import {setCurrentUser} from '../actions/Login.js';
import Notification from "../components/Notification";
import Helpers from "../../../lib/helpers";

class General {
	constructor() {

	}

	Link2(path) {
		let state = store.getState();
		let url = '';

		if(state.auth.currentAccount == false) {
			path = '/login';
		}

		if(Helpers.isProduction()) {
			url = "https://app.crall.io/v2/#/"+state.auth.currentAccount+path;
		}else{
			url = "https://app.crall.dev:3000/#/"+state.auth.currentAccount+path;
		}

		return url;
	}

	Link(path) {
		let state = store.getState();
		if(state.auth.currentAccount == false) {
			return '/login';
		}else{
			return '/'+state.auth.currentAccount+path;
		}
	}

	requestAccessToken(path) {
		axios.get('/me/token').then((res) => {
            window.location.href = path+'?token='+res.data;
		});
	}

    LinkIsActive(path) {
        let state = store.getState();
        if(state.auth.currentAccount == false) {
            return '/login';
        }else{
            return '/'+state.auth.currentAccount+path;
        }
    }

	appHasType(type) {
		for(let i in store.getState().general.apps) {
			if(store.getState().general.apps[i].type == type) {
				return store.getState().general.apps[i];
			}
		}

		return false;
	}

	appGetType(type) {
		let apps = [];

		for(let i in store.getState().general.apps) {
			if(store.getState().general.apps[i].type == type) {
				apps.push(store.getState().general.apps[i]);
			}
		}

		return apps;
	}

	loadScript(src) {
		let state = store.getState();
        return new Promise((resolve,reject) => {

		if(state.general.scripts.includes(src)) {
			resolve();
           return;
		}

        store.dispatch(addScript(src));


            let scr = document.createElement('script');
            scr.type = 'text/javascript';

            if (scr.readyState) { // IE
                scr.onreadystatechange = function() {
                    if (scr.readyState == 4 || scr.readyState ==='complete') {
                        scr.onreadystatechange = null;
                        resolve();
                    }
                };
            } else { // Others
                scr.onload = () => resolve();
            }

            scr.src = src;
            document.getElementsByTagName('head')[0].appendChild(scr);
		});

	}

	fetchGeneral() {
		return axios.get('/general').then(res => {
			if(store.getState().general.platform.version) {
				if(store.getState().general.platform.version != res.data.platform.version) {
                    store.dispatch(setGlobalKey('needUpdate',true));
				}
			}
            store.dispatch(setCurrentUser(Auth.getToken(),res.data.me));
            Auth.authenticate(Auth.getToken());

            let shownMessages = store.getState().general.shownMessages;

            if(res.data.notifications.length > 0) {
            	for(let i in res.data.notifications) {
            		if(!shownMessages.includes(res.data.notifications[i].id)) {
                        store.dispatch(addNotificationMessage(res.data.notifications[i].id));
                        Notification[res.data.notifications[i].type](res.data.notifications[i].message);
					}
				}
			}

			store.dispatch(addUsers(res.data.users));
			store.dispatch(setGlobalKey('settings',res.data.settings));
			store.dispatch(setGlobalKey('apps',res.data.apps));
			store.dispatch(setGlobalKey('plans',res.data.plans));
			store.dispatch(setGlobalKey('app',res.data.settings));
			store.dispatch(setGlobalKey('platform',res.data.platform));
			store.dispatch(setGlobalKey('account',res.data.account));
		});
	}
}

//store.dispatch(addVisitors('test'));

export default new General();



// WEBPACK FOOTER //
// ./modules/General.js